import React, { useContext, useEffect, useState } from "react";
import { MuiOtpInput } from "mui-one-time-password-input";
import "../../../features2/registration/styles/RegistrationStyle.css"
import Loader, { UserDeviceStorage } from "../../../utils/Utils";
import { useAlert } from "../../../components/AlertContextComponent";
import { VerificationRequest } from "../data/request/VerificationRequest";
import { VerificationResponse } from "../data/response/VerificationResponse";
import { useApi } from "../../../service/ApiContext";
import RegistrationClient from "../data/api/RegistrationClient";
import { multiStepContext } from "./ContextApiComponent";
import Logger from "../../../utils/Logger";
import { logActionEvent } from "../../../analytics/analytics_utils";
import { useNavigate } from "react-router-dom";
import { RegistrationRequest } from "../data/request/RegistrationRequest";
import { RegistrationResponse } from "../data/response/RegistrationResponse";
import strings from "../../../utils/Strings";
import analytics_strings from "../../../analytics/analytics_strings";

const ForthStep = () => {
  const api = useApi();
  const { showAlert } = useAlert();
  const { setCurrentStep, userData, setUserData, currentStep, submitData } =
    useContext(multiStepContext)!;
  const [otp, setOtp] = React.useState("");
  const [errors, setErrors] = useState<any>({});
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();
  // Function to be called when OTP is fully entered
  const handleOtpComplete = (otp: string) => {
    // Replace with your desired functionality
    Logger.info("OTP entered:", otp);
    // For example, you might want to submit the OTP or validate it
  };

  const sendOtp = async () => {
    Loader.showLoading("Loading...");
    const param: VerificationRequest = {
      email_address: userData["corporateEmail"],
      entity: "USER",
    };
    try {
      const response = await api
        .post<VerificationResponse>(RegistrationClient.emailValidation, param)
        .then((res) => {
          if (res.data.error === null) {
            showAlert({
              show: true,
              title: "Info",
              message: res.data.detail,
              button1Text: "Cancel",
              alertType: "success",
              onlyNeedOneButton: true,
            });
          } else {
            showAlert({
              show: true,
              title: "Already Exist",
              message: res.data.error,
              button1Text: "Cancel",
              alertType: "success",
              onlyNeedOneButton: true,
            });
          }
          Logger.info("response", res.data);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const verification = async (otp: string) => {
    Loader.showLoading("Loading...");
    const param: VerificationRequest = {
      email_address: userData["corporateEmail"],
      entity: "USER",
      otp: parseInt(otp.trim(), 10).toString(),
    };
    try {
      const response = await api
        .post<VerificationResponse>(RegistrationClient.verificationOtp, param)
        .then((res) => {
          if (res.data.error === null) {
            Logger.info("Correct otp");
            setDisabled(false);
          } else {
            showAlert({
              show: true,
              title: "Error",
              message: res.data.error,
              button1Text: "Cancel",
              alertType: "error",
              onlyNeedOneButton: true,
            });
          }
          Logger.info("response", res.data);
        })
        .catch((error) => {
          Logger.info("error response", error);
        });
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const handleChange = (newValue: string) => {
    setOtp(newValue);
  };

  useEffect(() => {
    // Check if OTP length matches the expected length (e.g., 4 digits)
    if (otp.length === 4) {
      verification(otp);
    }
  }, [otp]);

  const registration = async () => {
    Loader.showLoading("Loading...");
    const param: RegistrationRequest = {
      admission_year: userData["admissionYear"] || null,
      candidate_password: userData["password"] || null,
      course: userData["admissionYear"] || null,
      education: userData["educationalQualification"] || null,
      email_address: userData["corporateEmail"] || null,
      first_name: userData["firstName"] || null,
      institute_name: userData["instituteName"] || null,
      last_name: userData["lastName"] || null,
      roll_number: userData["rollNo"] || null,
    };

    try {
      await api
        .post<RegistrationResponse>(RegistrationClient.registration, param)
        .then((res) => {
          if (res.data.error) {
            logActionEvent(analytics_strings.analytics_events.registerFailed, {
              emailId: param.email_address,
              error: res.data.error,
            });
            Logger.info("response", res.data);
            showAlert({
              show: true,
              title: "Error",
              message: res.data.error,
              button1Text: "Cancel",
              alertType: "error",
              onlyNeedOneButton: true,
              btn1onPressed: () => navigate(strings.routing.signupPage),
            });
          } // Redirect to the login page after registration
          else {
            logActionEvent(analytics_strings.analytics_events.registerSucces, {
              emailId: param.email_address,
              message: analytics_strings.analytics_events.registerSucces,
            });
            showAlert({
              show: true,
              title: "Success",
              message: "Registration successfully completed",
              button1Text: "Ok",
              alertType: "success",
              onlyNeedOneButton: true,
              btn1onPressed: () => {
                UserDeviceStorage.setDeviceId(
                  param.email_address!.toString(),
                  res.data.device_id ?? ""
                );
                navigate(strings.routing.loginPage);
              },
            });
          }
        })
        .catch((error) => {
          Logger.info("error response", error);
          logActionEvent(analytics_strings.analytics_events.registerException, {
            emailId: param.email_address,
            expection: error,
          });
          setErrors("Failed to register. Please try again.");
        });
    } catch (error) {
      Logger.info("error response", error);
      setErrors("Failed to register. Please try again.");
    } finally {
      Loader.dismissLoading();
    }
  };

  return (
    <div className="otp-input-container">
      {/* <h2>
        Enter the code sent to provided email id. Click{" "}
        <span className="login-link" onClick={() => sendOtp()}>
          here
        </span>{" "}
        to regenerate code.
      </h2> */}
      <div>
      <MuiOtpInput
        value={otp}
        onChange={handleChange}
        // sx={{
        //   "& .MuiOutlinedInput-root": {
        //     borderTop: "none !important", // Remove default border
        //     borderBottom: "2px solid #b6aeae", // Add underline
        //     borderRadius: "0 !important",
        //     textAlign: "center", // Center align text
        //     width: "60px", // Adjust width
        //     fontSize: "18px", // Customize font size
        //     margin: "0 30px", // Spacing between input fields
        //   },
        //   "& .MuiOutlinedInput-root.Mui-focused": {
        //     borderBottom: "2px solid blue !important", // Focus underline effect
        //   },
        //   "& .MuiOutlinedInput-notchedOutline": {
        //     border: "none !important", // Remove outline (common issue)
        //     borderRadius: "0 !important",
        //   },
        // }}
       sx={{
  "& .MuiOutlinedInput-root": {
    border: "2px solid #e5e7eb",
    borderRadius: "10px",
    width: "60px",
    height: "60px",
    margin: "0 10px",
    backgroundColor: "#fff",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    "& fieldset": {
      border: "none",
    },

    "& input": {
      textAlign: "center",
      fontSize: "18px",
      fontWeight: 600,
      padding: "0px",
      height: "100%",
      display: "flex",
      alignItems: "center",
    },
  },
}}
        className="otp-input-field"
      />
 <h2>
        Enter the code sent to provided email id. Click{" "}
        <span className="login-link" style={{color:"#2563eb"}} onClick={() => sendOtp()}>
          click here
        </span>{" "}
        to regenerate code.
      </h2>
      </div>
      <center>
        <div className="form-button">
          <button
            className="buttonForForm"
            onClick={registration}
            style={{backgroundColor:disabled?"#eaeff9":"#ffc85d"}}
            disabled={disabled} // Disable button conditionally
          >
            Submit
          </button>
        </div>
      </center>
    </div>
  );
};

export default ForthStep;
